import { useMutation } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

// Hands the zip to the browser as a normal file download.
const saveBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

const useDownloadCollectionAssets = () =>
  useMutation({
    mutationKey: ["download-collection-assets"],
    mutationFn: async (collectionId: string) => {
      const { blob, fileName } =
        await collectionApiClient.downloadCollectionAssets(collectionId);
      saveBlob(blob, fileName);
    },
  });

export default useDownloadCollectionAssets;
